module.exports = __webpack_public_path__ + "static/media/sys.a08cf686.svg";